export const LABELS = {
  SEARCH: 'Search',
  LOADING: 'Searching...',
  NOT_FOUND: 'No matching properties found',
};
